export var SCREEN_TABS_HISTORY_TYPE = 'SCREEN_TABS';
export var FIELD_HISTORY_TYPE = 'FIELD';